import React from 'react';
import PageContainer from '../components/PageContainer';
import MainContent from '../components/MainContent';
import PageTitle from '../components/Common/PageTitle/PageTitle';


const NoDataPage = () => {


    return (
        <PageContainer>
            <MainContent>
                <PageTitle
                    title="Oops!"
                    description="This data is nolonger available."
                    iconClass="fa-solid fa-circle-xmark"
                />
                <div className="card mb-3">
                    <div className="card-body">
                       
                    </div>
                </div>
            </MainContent>
        </PageContainer>
    );
};

export default NoDataPage;
